import React from 'react';
import { Box, Card, Typography, Skeleton, Stack } from '@mui/material';

const SquadCardSkeleton = ({ competitionColors }) => {
  return (
    <Card
      sx={{
        p: 1,
        minHeight: 140,
        height: '100%',
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        border: `1px solid ${competitionColors?.primary || '#2196f3'}20`,
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Squad Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={0.5}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton
            variant="text"
            width={30}
            height={20}
            sx={{ ml: 1 }}
          />
        </Box>
      </Stack>

      {/* Athlete List Skeleton */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Box
            key={item}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              py: 0.25
            }}
          >
            {/* Avatar Circle */}
            <Skeleton
              variant="circular"
              width={24}
              height={24}
              sx={{ flexShrink: 0 }}
            />

            {/* Name and Details */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.25 }}>
              <Skeleton variant="text" width="70%" height={16} />
              <Skeleton variant="text" width="50%" height={12} />
            </Box>

            {/* Number */}
            <Skeleton variant="text" width={40} height={16} />
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default SquadCardSkeleton;
